import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const MAINTENANCE_VENDOR_FIELDS = [
  {
    question: VENDORS.MAINTENANCE_SOFTWARE_VENDOR,
    title: 'Maintenance software',
    invoiceFileTypeId: FILE_TYPES.MAINTENANCE_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MAINTENANCE_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MAINTENANCE_SERVICE_PROVIDER,
    title: 'Maintenance service provider',
    invoiceFileTypeId: FILE_TYPES.MAINTENANCE_SERVICE_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.MAINTENANCE_SERVICE_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.ELEVATOR_SERVICE_COMPANY,
    title: 'Elevator service company',
    invoiceFileTypeId: FILE_TYPES.ELEVATOR_SERVICE_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.ELEVATOR_SERVICE_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.MAINTENANCE_SUPPLIES_VENDOR,
    title: 'Maintenance supplies vendor',
    invoiceFileTypeId: FILE_TYPES.MAINTENANCE_SUPPLIES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MAINTENANCE_SUPPLIES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.FIRE_SAFETY_VENDOR,
    title: 'Fire safety vendor',
    invoiceFileTypeId: FILE_TYPES.FIRE_SAFETY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.FIRE_SAFETY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.SECURITY_SYSTEM_VENDOR,
    title: 'Security system vendor',
    invoiceFileTypeId: FILE_TYPES.SECURITY_SYSTEM_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.SECURITY_SYSTEM_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.TV_AND_CABLE_VENDOR,
    title: 'TV and cable vendor',
    invoiceFileTypeId: FILE_TYPES.TV_AND_CABLE_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.TV_AND_CABLE_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.ELECTRIC_UTILITY_VENDOR,
    title: 'Electric utility',
    invoiceFileTypeId: FILE_TYPES.ELECTRIC_UTILITY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.ELECTRIC_UTILITY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.GAS_UTILITY_VENDOR,
    title: 'Gas utility',
    invoiceFileTypeId: FILE_TYPES.GAS_UTILITY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.GAS_UTILITY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.WATER_AND_SEWER_UTILITY_VENDOR,
    title: 'Water and sewer utility',
    invoiceFileTypeId: FILE_TYPES.WATER_AND_SEWER_UTILITY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.WATER_AND_SEWER_UTILITY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.WASTE_HAULING_VENDOR,
    title: 'Waste hauling vendor',
    invoiceFileTypeId: FILE_TYPES.WASTE_HAULING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.WASTE_HAULING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MAINTENANCE_EQUIPMENT_RENTAL_VENDOR,
    title: 'Maintenance equipment rental vendor',
    invoiceFileTypeId: FILE_TYPES.MAINTENANCE_EQUIPMENT_RENTAL_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MAINTENANCE_EQUIPMENT_RENTAL_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PEST_CONTROL_VENDOR,
    title: 'Pest control vendor',
    invoiceFileTypeId: FILE_TYPES.PEST_CONTROL_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PEST_CONTROL_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.GENERATOR_SERVICE_COMPANY,
    title: 'Generator service company',
    invoiceFileTypeId: FILE_TYPES.GENERATOR_SERVICE_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.GENERATOR_SERVICE_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.LANDSCAPING_VENDOR,
    title: 'Landscaping vendor',
    invoiceFileTypeId: FILE_TYPES.LANDSCAPING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.LANDSCAPING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.HOOD_VENT_CLEANING_VENDOR,
    title: 'Hood vent cleaning provider',
    invoiceFileTypeId: FILE_TYPES.HOOD_VENT_CLEANING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.HOOD_VENT_CLEANING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.GREASE_TRAP_CLEANING_PROVIDER,
    title: 'Grease trap cleaning provider',
    invoiceFileTypeId: FILE_TYPES.GREASE_TRAP_CLEANING_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.GREASE_TRAP_CLEANING_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.WATER_SOFTENING_VENDOR,
    title: 'Water softening vendor',
    invoiceFileTypeId: FILE_TYPES.WATER_SOFTENING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.WATER_SOFTENING_VENDOR_CONTRACT,
  },
];
